export class Question {
  questionId!: number;
  taxPolicyId!: number;
  questionTypeId!: number;
  questionValueTypeId!: number;
  name!: string;
  text!: string;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
}
